module.exports = __webpack_public_path__ + "assets/img/image_chazhao.4ccacad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image_chazhao.png
// module id = UtLv
// module chunks = 1